<template>
    <div data-testid="comments">
        <v-list-item
            v-if="listItemMode && !hideTrigger"
            class="cursor-pointer hoverable-caccounting all-width radius-small"
            @click="openConversation"
            data-testid="comments__open-btn"
        >
            <v-list-item-icon class="mr-2 my-0 align-self-center">
                <v-badge
                    class="comments__badge-wrap comments__menu-badge"
                    color="error"
                    offset-x="8"
                    offset-y="8"
                    top
                    dot
                    :value="notify"
                    data-testid="comments__badge"
                >
                    <img
                        :class="['comments__icon', iconClassList]"
                        data-testid="comments__icon-main"
                        src="/img/icons/fbc-icons/CommentsIcons.svg"
                        alt="Comments Icon"
                    />
                </v-badge>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title class="text-capitalize" data-testid="comments__title">
                    {{ menuLabelText }}
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-btn v-else-if="!hideTrigger" class="comments__open-btn pa-0" name="conversations" text
            @click="openConversation"
            data-testid="comments__open-btn">
            <v-badge class="comments__badge-wrap" color="error" offset-x="8" offset-y="8" top dot :value="notify" data-testid="comments__badge">
                <img
                    :class="['comments__icon', iconClassList]"
                    data-testid="comments__icon-main"
                    src="/img/icons/fbc-icons/CommentsIcons.svg"
                    alt="Comments Icon"
                />
            </v-badge>
            <span v-if="showname" class="text-capitalize white--text" data-testid="comments__title">Comments</span>
        </v-btn>

        <lb-drawer v-model="dialog" :heading="heading" persistent :dailogboxOnly="true" data-testid="comments__drawer">
            <template v-slot:body>
                <div style="max-height:70vh; overflow:scroll" ref="chatContainer" data-testid="comments__body">
                    <div class="comments__list" data-testid="comments__chat-container">
                        <div
                            v-for="(item, index) in conversationList"
                            :key="index"
                            class="comments__item"
                            :class="isSelfMessage(item) ? 'comments__item--self' : 'comments__item--other'"
                            data-testid="comments__item"
                        >
                            <div class="comments__avatar-col">
                                <v-tooltip v-if="shouldShowAvatar(index)" bottom data-testid="comments__item-tooltip">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-avatar
                                            size="30"
                                            elevation="10"
                                            color="indigo"
                                            v-bind="attrs"
                                            v-on="on"
                                            :data-testid="isSelfMessage(item) ? 'comments__item-avatar' : 'comments__item-avatar-other'"
                                        >
                                            <v-img
                                                v-if="shouldShowProfileImage(item)"
                                                alt="Avatar"
                                                width="30"
                                                height="30"
                                                :src="getUserProfileUrl(item)"
                                                @error="onProfileImageError(item)"
                                                data-testid="comments__item-avatar-img"
                                            />
                                            <span
                                                class="white--text"
                                                v-else
                                                :data-testid="isSelfMessage(item) ? 'comments__item-avatar-initial' : 'comments__item-avatar-initial-other'"
                                            >
                                                {{ getUserInitials(item) }}
                                            </span>
                                        </v-avatar>
                                    </template>
                                    <span :data-testid="isSelfMessage(item) ? 'comments__item-avatar-name-tooltip' : 'comments__item-avatar-name-other'">
                                        {{ getUserName(item) }}
                                    </span>
                                </v-tooltip>
                                <span v-else class="comments__avatar-spacer" data-testid="comments__item-avatar-gap"></span>
                            </div>

                            <div class="comments__content-col">
                                <div
                                    class="comments__meta"
                                    :class="isSelfMessage(item) ? 'comments__meta--self' : 'comments__meta--other'"
                                    :data-testid="isSelfMessage(item) ? 'comments__item-row' : 'comments__item-tooltip-other'"
                                >
                                    <span
                                        v-if="shouldShowAvatar(index)"
                                        class="comments__thread-name"
                                        :data-testid="isSelfMessage(item) ? 'comments__item-avatar-name' : 'comments__item-avatar-name-label-other'"
                                    >
                                        {{ getUserName(item) }}
                                    </span>
                                    <span
                                        class="timeFont"
                                        :data-testid="isSelfMessage(item) ? 'comments__item-date' : 'comments__item-date-other'"
                                    >
                                        {{ $nova.formatDateTime(item.created_at, 'DD MMM yyyy hh:mm A') }}
                                    </span>
                                </div>

                                <v-card
                                    class="comments__message-card shadow-off radius-small"
                                    :color="isSelfMessage(item) ? 'purpleborder' : 'lightgray'"
                                    :data-testid="isSelfMessage(item) ? 'comments__item-message-card' : 'comments__item-message-card-other'"
                                >
                                    <v-card-text
                                        class="shadow-off pa-3"
                                        :data-testid="isSelfMessage(item) ? 'comments__item-message-text' : 'comments__item-message-text-other'"
                                    >
                                        <div
                                            :class="isSelfMessage(item) ? 'self-message' : 'self-message'"
                                            :id="isSelfMessage(item) ? 'sent-chat-message-' + index : 'receive-chat-message-' + index"
                                            v-html="formatCommentMessage(item.value)"
                                            :data-testid="isSelfMessage(item) ? 'comments__item-message' : 'comments__item-message-other'"
                                        />
                                    </v-card-text>
                                </v-card>
                            </div>
                        </div>
                        <div v-if="(conversationList || []).length === 0"
                            class="d-flex flex-column align-center justify-center  all-height" data-testid="comments__empty-state">
                            <v-spacer data-testid="comments__empty-state-spacer-top"></v-spacer>
                            <p class="text-subtitle-1 grey--text" data-testid="comments__empty-state-label">Be the first one to comment</p>
                            <v-spacer data-testid="comments__empty-state-spacer-bottom"></v-spacer>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:actions v-if="!closed">
                <div class="d-flex align-center mb-1" v-if="recurring" data-testid="comments__recurring-row">
                    <v-checkbox label="Reucurring Comment" class="mr-2 pa-0 ma-0" dense hide-details
                        v-model="recurringMsg" data-testid="comments__recurring-checkbox"></v-checkbox>
                    <v-tooltip right content-class="tooltip-right" data-testid="comments__recurring-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon color="blue-grey lighten-2" dark v-bind="attrs" v-on="on" data-testid="comments__recurring-icon">
                                mdi-help-circle-outline
                            </v-icon>
                        </template>
                        <span class="text-justify" data-testid="comments__recurring-tooltip-text">{{ recurringtext }}</span>
                    </v-tooltip>
                </div>
                <div class="d-flex align-center all-width" data-testid="comments__input-row">
                    <lb-string placeholder="Type your message here" label="" hidedetails @enter="sendQuery()"
                        v-model="queryMsg" :isRequired="true" :error="sendError" data-testid="comments__input" />
                    <v-btn
                        class="primaryBtn ml-3"
                        :loading="sendLoading || loading"
                        :disabled="!canSendComment || sendLoading || loading"
                        @click="sendQuery()"
                        data-testid="comments__send-btn"
                    >
                        Send
                    </v-btn>
                </div>
            </template>
        </lb-drawer>
    </div>
</template>
<script>
import { formatCommentMessage } from '@/views/common/commentMessageFormat';

export default {
    name: "conversations",
    model: {
        prop: 'drawerOpen',
        event: 'input',
    },
    data() {
        return {
            internalDialog: false,
            loading: false,
            conversationList: [],
            queryMsg: "",
            recurringMsg: false,
            failedProfileUrls: {},
        };
    },
    props: {
        /** Drawer open state (use with hideTrigger + v-model) */
        drawerOpen: {
            type: Boolean,
            default: undefined,
        },
        /** Hide toolbar button; parent opens drawer via v-model */
        hideTrigger: {
            type: Boolean,
            default: false,
        },
        /** Render as a v-list-item row (task row action menu) */
        listItemMode: {
            type: Boolean,
            default: false,
        },
        /** Label shown in listItemMode; defaults to heading */
        menuLabel: {
            type: String,
            default: '',
        },
        /** Embedded comments list (Information Manager); maps comment → value */
        comments: {
            type: Array,
            default: () => [],
        },
        /** Parent-controlled send loading (embedded mode) */
        sendLoading: {
            type: Boolean,
            default: false,
        },
        /** Parent-controlled send validation error (embedded mode) */
        sendError: {
            type: String,
            default: '',
        },
        getapi: {
            type: String,
            default: "",
        },
        sendapi: {
            type: String,
            default: "",
        },
        readapi: {
            type: String,
            default: "",
        },
        heading: {
            type: String,
            default: "Conversation",
        },
        recurring: {
            type: Boolean,
            default: false,
        },
        recurringtext: {
            type: String,
            default: "Requirements comments for next time",
        },
        notify: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: "800",
        },
        type: {
            type: String,
            default: "string",
        },
        closed: {
            type: Boolean,
            default: true,
        },
        highlight: {
            type: Boolean,
            default: false
        },
        /** White icon for dark backgrounds (e.g. bulk action bar) */
        iconLight: {
            type: Boolean,
            default: false,
        },
        showprofile: {
            type: Boolean,
            default: true
        },
        showname:{
            type:Boolean,
            default: false,
        },
        userList: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        dialog: {
            get() {
                return this.hideTrigger ? !!this.drawerOpen : this.internalDialog;
            },
            set(val) {
                if (this.hideTrigger) {
                    this.$emit('input', val);
                } else {
                    this.internalDialog = val;
                }
            },
        },
        currentUserId() {
            return this.$store.state.user?.id || this.$store.state.user?._id || '';
        },
        menuLabelText() {
            return this.menuLabel || this.heading || 'Comments';
        },
        iconClassList() {
            return {
                'comments__icon--highlight': this.highlight && !this.iconLight,
                'comments__icon--light': this.iconLight,
            };
        },
        canSendComment() {
            return Boolean(this.queryMsg && this.queryMsg.trim());
        },
    },
    watch: {
        conversationList() {
            this.failedProfileUrls = {};
        },
        drawerOpen(val) {
            // Only sync prop-backed comments; API mode loads via openConversation/getProjectCon
            if (this.hideTrigger && val && !this.getapi) {
                this.syncCommentsFromProp();
                this.$nextTick(() => this.scrollToBottom());
            }
        },
        comments: {
            handler() {
                if (this.hideTrigger && this.dialog) {
                    this.syncCommentsFromProp();
                    this.$nextTick(() => this.scrollToBottom());
                }
            },
            deep: true,
        },
    },
    methods: {
        openConversation() {
            this.conversationList = [];
            this.getProjectCon(true);
        },
        syncCommentsFromProp() {
            this.conversationList = (this.comments || []).map((item) => ({
                ...item,
                value: item.value != null ? item.value : item.comment,
            }));
        },
        resetMessage() {
            this.queryMsg = '';
        },
        sendQuery() {
            if (!this.canSendComment) return;
            const text = this.queryMsg.trim();
            if (this.hideTrigger && !this.sendapi) {
                this.$emit('send', text);
                return;
            }
            this.loading = true;
            let dataObject = {
                type: this.type,
                value: text,
                status: this.status,
            };
            // console.log(dataObject);
            let successflag = false;
            this.axios
                .post(this.sendapi, { data: dataObject })
                .then((dt) => {
                    if (dt.data.status === "success") {
                        successflag = true;
                        // this.$store.commit("sbSuccess", "successfully sended");
                        this.queryMsg = "";

                    } else throw Error(dt.data.message || "Unknown error")
                })
                .catch((err) => {
                    this.$store.commit("sbError", err.message || err || "Unknown error!");
                    console.log(err);
                })
                .finally(() => {
                    this.loading = false;
                    if (successflag) this.getProjectCon();
                });
        },
        getProjectCon(mark = false) {
            // Embedded mode (parent-supplied comments, no getapi)
            if (this.hideTrigger && !this.getapi) {
                this.dialog = true;
                this.syncCommentsFromProp();
                if (mark) this.$emit('markread');
                this.$nextTick(() => this.scrollToBottom());
                return;
            }
            this.dialog = true;
            this.loading = true;
            this.axios
                .post(this.getapi)
                .then((dt) => {
                    if (dt.data.status === "success") {
                        this.conversationList = dt.data.data;
                        this.dialog=true                        
                        if (mark) this.markAsRead();
                    } else throw Error(dt.data.message || "Unknown error")
                    // console.log(this.conversationList);
                })
                .catch((err) => {
                    this.$store.commit("sbError", err.message || err || "Unknown error!");
                    console.log(err);
                })
                .finally(() => {
                    this.loading = false;
                    this.scrollToBottom();
                });
        },
        markAsRead() {
            this.axios
                .post(this.readapi)
                .then((dt) => {
                    if (dt.data.status === "success") {
                        this.$emit("markread");
                    } else throw Error(dt.data.message || "Unknown error")
                    // console.log(this.conversationList);
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                });
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const chatContainer = this.$refs.chatContainer;
                if (chatContainer) {
                    chatContainer.scrollTop = chatContainer.scrollHeight;
                }
            });
        },
        getCurrentUserId() {
            return this.$store.state.user?.id || this.$store.state.user?._id || null;
        },
        findUserRecord(userId) {
            if (userId == null || !this.userList.length) return null;
            return this.userList.find(
                (u) => String(u._id) === String(userId) || String(u.id) === String(userId)
            ) || null;
        },
        resolveProfileUrl(record) {
            if (!record) return null;
            const url = record.profile_url || record.profile || record.avatar_url || record.avatar;
            return (typeof url === 'string' && url.trim()) ? url.trim() : null;
        },
        shouldShowProfileImage(item) {
            if (!this.showprofile) return false;
            const url = this.getUserProfileUrl(item);
            if (!url || this.failedProfileUrls[url]) return false;
            return true;
        },
        onProfileImageError(item) {
            const url = this.getUserProfileUrl(item);
            if (url) this.$set(this.failedProfileUrls, url, true);
        },
        getUserName(item) {
            if (item?.user_detail?.name) {
                return item.user_detail.name;
            }
            const userId = item?.user;
            if (userId != null && String(userId) === String(this.getCurrentUserId())) {
                return this.$store.state.user?.name || this.$store.state.user?.email || 'NA';
            }
            const user = this.findUserRecord(userId);
            if (user?.name) return user.name;
            if (item?.user_detail?.email) {
                return item.user_detail.email;
            }
            if (user?.email) return user.email;
            return 'NA';
        },
        getUserInitials(item) {
            const name = this.getUserName(item);
            if (name && name !== 'NA') return name.charAt(0).toUpperCase();
            const email = item?.user_detail?.email
                || this.findUserRecord(item?.user)?.email
                || (String(item?.user) === String(this.getCurrentUserId()) ? this.$store.state.user?.email : null);
            if (email) return email.charAt(0).toUpperCase();
            return '?';
        },
        getUserProfileUrl(item) {
            const fromDetail = this.resolveProfileUrl(item?.user_detail);
            if (fromDetail) return fromDetail;

            const userId = item?.user;
            if (userId != null && String(userId) === String(this.getCurrentUserId())) {
                const fromStore = this.resolveProfileUrl(this.$store.state.user);
                if (fromStore) return fromStore;
            }

            return this.resolveProfileUrl(this.findUserRecord(userId));
        },
        formatCommentMessage,
        isSelfMessage(item) {
            const itemUserId = item?.user;
            const storeUser = this.$store.state.user || {};
            const storeIds = [storeUser.id, storeUser._id].filter(Boolean).map(String);
            if (storeIds.includes(String(itemUserId))) return true;
            return String(itemUserId) === String(this.currentUserId);
        },
        shouldShowAvatar(index) {
            const item = this.conversationList[index];
            const previous = this.conversationList[index - 1];
            return !previous || String(previous.user) !== String(item.user);
        },
    },
    mounted() {
        // Auto-scroll to the bottom when the component is mounted
        this.scrollToBottom();
    }
};
</script>

<style lang="scss">
@import '@/styles/_comments-thread.scss';
</style>
